// Modules
import React, { createContext, useState, useContext, useRef } from 'react'

// Application
import { snackbarStateType } from 'redesign/typings/snackbar'

interface Props {
    state: {
        snackbarProps: snackbarStateType
        counterRetry: React.MutableRefObject<number>
    }

    operations: {
        setSnackbarProps: (value: snackbarStateType) => void
    }
}

const SnackbarContext = createContext<Props>({} as Props)

export const SnackbarProvider: React.FC = ({ children }) => {
    const [snackbarProps, setSnackbarProps] = useState<snackbarStateType>({
        open: false,
        duration: 3000,
        variant: 'simple',
        message: '',
    })

    const counterRetry = useRef(0)

    return (
        <SnackbarContext.Provider
            value={{
                state: {
                    snackbarProps,
                    counterRetry,
                },
                operations: {
                    setSnackbarProps,
                },
            }}
        >
            {children}
        </SnackbarContext.Provider>
    )
}

export function useSnackbarContext(): Props {
    const context = useContext(SnackbarContext)
    return context
}
